import { FIELD_TYPE_DROPDOWN } from '../../../constants/entity/field-types';

const SettingsDealTemplateValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const requiredFields: string[] = [
    'title',
    'type',
  ];

  const dealContactsGroupRequiredFields: string[] = [
    'name',
  ];

  const dealInvestmentReturnsItemRequiredFields: string[] = [
    'name',
  ];

  const dealCapitalizationGroupRequiredFields: string[] = [
    'name',
  ];

  const dealTermGroupRequiredFields: string[] = [
    'name',
  ];

  const dealValuationFileGroupRequiredFields: string[] = [
    'name',
  ];

  const dealTaskGroupRequiredFields: string[] = [
    'name',
  ];

  const dealTaskRequiredFields: string[] = [
    'name',
  ];

  const dealFileGroupRequiredFields: string[] = [
    'name',
  ];

  const dealParticipantGroupRequiredFields: string[] = [
    'name',
  ];

  const customSectionRequiredFields: string[] = [
    'name',
  ];

  const customSectionFieldRequiredFields: string[] = [
    'name',
    'type',
  ];

  const customListTypeRequiredFields: string[] = [
    'title',
  ];

  const customListTypeOptionRequiredFields: string[] = [
    'title',
  ];

  requiredFields.forEach((field: string): void => {
    if (!values[field] || !values[field].toString().trim()) {
      errors[field] = 'Required';
    }
  });

  if (values.initialData && Object.keys(values.initialData).length) {
    errors.initialData = {};

    errors.initialData.dealContacts = {};
    if (values.initialData.dealContacts && Object.keys(values.initialData.dealContacts).length) {
      Object.keys(values.initialData.dealContacts).forEach((dealContactsGroupIndex: string): void => {
        errors.initialData.dealContacts[dealContactsGroupIndex] = {};

        const dealContactsGroup: ValidationEntityInput = values.initialData.dealContacts[dealContactsGroupIndex];

        if (dealContactsGroup) {
          dealContactsGroupRequiredFields.forEach((field: string): void => {
            if ((!dealContactsGroup[field] || !dealContactsGroup[field].toString().trim())
              && dealContactsGroup[field] !== null) {
              errors.initialData.dealContacts[dealContactsGroupIndex][field] = 'Required';
            }
          });
        }

        if (errors.initialData.dealContacts[dealContactsGroupIndex]
          && !Object.keys(errors.initialData.dealContacts[dealContactsGroupIndex]).length) {
          delete errors.initialData.dealContacts[dealContactsGroupIndex];
        }
      });
    }
    if (errors.initialData.dealContacts && !Object.keys(errors.initialData.dealContacts).length) {
      delete errors.initialData.dealContacts;
    }

    errors.initialData.dealInvestmentReturns = {};
    if (values.initialData.dealInvestmentReturns && Object.keys(values.initialData.dealInvestmentReturns).length) {
      Object.keys(values.initialData.dealInvestmentReturns).forEach((dealInvestmentReturnsItemIndex: string): void => {
        errors.initialData.dealInvestmentReturns[dealInvestmentReturnsItemIndex] = {};

        const dealInvestmentReturnsItem: ValidationEntityInput = values.initialData
          .dealInvestmentReturns[dealInvestmentReturnsItemIndex];

        if (dealInvestmentReturnsItem) {
          dealInvestmentReturnsItemRequiredFields.forEach((field: string): void => {
            if ((!dealInvestmentReturnsItem[field] || !dealInvestmentReturnsItem[field].toString().trim())
              && dealInvestmentReturnsItem[field] !== null) {
              errors.initialData.dealInvestmentReturns[dealInvestmentReturnsItemIndex][field] = 'Required';
            }
          });
        }

        if (errors.initialData.dealInvestmentReturns[dealInvestmentReturnsItemIndex]
          && !Object.keys(errors.initialData.dealInvestmentReturns[dealInvestmentReturnsItemIndex]).length) {
          delete errors.initialData.dealInvestmentReturns[dealInvestmentReturnsItemIndex];
        }
      });
    }
    if (errors.initialData.dealInvestmentReturns && !Object.keys(errors.initialData.dealInvestmentReturns).length) {
      delete errors.initialData.dealInvestmentReturns;
    }

    errors.initialData.dealCapitalization = {};
    if (values.initialData.dealCapitalization) {
      errors.initialData.dealCapitalization.sources = {};
      if (values.initialData.dealCapitalization.sources
        && Object.keys(values.initialData.dealCapitalization.sources).length) {
        Object.keys(values.initialData.dealCapitalization.sources).forEach((
          dealCapitalizationGroupIndex: string,
        ): void => {
          errors.initialData.dealCapitalization.sources[dealCapitalizationGroupIndex] = {};

          const dealCapitalizationGroup: ValidationEntityInput = values.initialData.dealCapitalization
            .sources[dealCapitalizationGroupIndex];

          if (dealCapitalizationGroup) {
            dealCapitalizationGroupRequiredFields.forEach((field: string): void => {
              if ((!dealCapitalizationGroup[field] || !dealCapitalizationGroup[field].toString().trim())
                && dealCapitalizationGroup[field] !== null) {
                errors.initialData.dealCapitalization.sources[dealCapitalizationGroupIndex][field] = 'Required';
              }
            });
          }

          if (errors.initialData.dealCapitalization.sources[dealCapitalizationGroupIndex]
            && !Object.keys(errors.initialData.dealCapitalization.sources[dealCapitalizationGroupIndex]).length) {
            delete errors.initialData.dealCapitalization.sources[dealCapitalizationGroupIndex];
          }
        });
      }
      if (errors.initialData.dealCapitalization.sources
        && !Object.keys(errors.initialData.dealCapitalization.sources).length) {
        delete errors.initialData.dealCapitalization.sources;
      }

      errors.initialData.dealCapitalization.uses = {};
      if (values.initialData.dealCapitalization.uses
        && Object.keys(values.initialData.dealCapitalization.uses).length) {
        Object.keys(values.initialData.dealCapitalization.uses).forEach((
          dealCapitalizationGroupIndex: string,
        ): void => {
          errors.initialData.dealCapitalization.uses[dealCapitalizationGroupIndex] = {};

          const dealCapitalizationGroup: ValidationEntityInput = values.initialData.dealCapitalization
            .uses[dealCapitalizationGroupIndex];

          if (dealCapitalizationGroup) {
            dealCapitalizationGroupRequiredFields.forEach((field: string): void => {
              if ((!dealCapitalizationGroup[field] || !dealCapitalizationGroup[field].toString().trim())
                && dealCapitalizationGroup[field] !== null) {
                errors.initialData.dealCapitalization.uses[dealCapitalizationGroupIndex][field] = 'Required';
              }
            });
          }

          if (errors.initialData.dealCapitalization.uses[dealCapitalizationGroupIndex]
            && !Object.keys(errors.initialData.dealCapitalization.uses[dealCapitalizationGroupIndex]).length) {
            delete errors.initialData.dealCapitalization.uses[dealCapitalizationGroupIndex];
          }
        });
      }
      if (errors.initialData.dealCapitalization.uses
        && !Object.keys(errors.initialData.dealCapitalization.uses).length) {
        delete errors.initialData.dealCapitalization.uses;
      }
    }
    if (errors.initialData.dealCapitalization && !Object.keys(errors.initialData.dealCapitalization).length) {
      delete errors.initialData.dealCapitalization;
    }

    errors.initialData.dealTermGroups = {};
    if (values.initialData.dealTermGroups && Object.keys(values.initialData.dealTermGroups).length) {
      Object.keys(values.initialData.dealTermGroups).forEach((dealTermGroupIndex: string): void => {
        errors.initialData.dealTermGroups[dealTermGroupIndex] = {};

        const dealTermGroup: ValidationEntityInput = values.initialData.dealTermGroups[dealTermGroupIndex];

        if (dealTermGroup) {
          dealTermGroupRequiredFields.forEach((field: string): void => {
            if ((!dealTermGroup[field] || !dealTermGroup[field].toString().trim()) && dealTermGroup[field] !== null) {
              errors.initialData.dealTermGroups[dealTermGroupIndex][field] = 'Required';
            }
          });
        }

        if (errors.initialData.dealTermGroups[dealTermGroupIndex]
          && !Object.keys(errors.initialData.dealTermGroups[dealTermGroupIndex]).length) {
          delete errors.initialData.dealTermGroups[dealTermGroupIndex];
        }
      });
    }
    if (errors.initialData.dealTermGroups && !Object.keys(errors.initialData.dealTermGroups).length) {
      delete errors.initialData.dealTermGroups;
    }

    errors.initialData.dealValuationFileGroups = {};
    if (values.initialData.dealValuationFileGroups && Object.keys(values.initialData.dealValuationFileGroups).length) {
      Object.keys(values.initialData.dealValuationFileGroups).forEach((dealFileGroupIndex: string): void => {
        errors.initialData.dealValuationFileGroups[dealFileGroupIndex] = {};

        const dealFileGroup: ValidationEntityInput = values.initialData.dealValuationFileGroups[dealFileGroupIndex];

        if (dealFileGroup) {
          dealValuationFileGroupRequiredFields.forEach((field: string): void => {
            if ((!dealFileGroup[field] || !dealFileGroup[field].toString().trim()) && dealFileGroup[field] !== null) {
              errors.initialData.dealValuationFileGroups[dealFileGroupIndex][field] = 'Required';
            }
          });
        }

        if (errors.initialData.dealValuationFileGroups[dealFileGroupIndex]
          && !Object.keys(errors.initialData.dealValuationFileGroups[dealFileGroupIndex]).length) {
          delete errors.initialData.dealValuationFileGroups[dealFileGroupIndex];
        }
      });
    }
    if (errors.initialData.dealValuationFileGroups && !Object.keys(errors.initialData.dealValuationFileGroups).length) {
      delete errors.initialData.dealValuationFileGroups;
    }

    errors.initialData.dealTaskGroups = {};
    if (values.initialData.dealTaskGroups && Object.keys(values.initialData.dealTaskGroups).length) {
      Object.keys(values.initialData.dealTaskGroups).forEach((dealTaskGroupIndex: string): void => {
        errors.initialData.dealTaskGroups[dealTaskGroupIndex] = {};

        const dealTaskGroup: ValidationEntityInput = values.initialData.dealTaskGroups[dealTaskGroupIndex];

        if (dealTaskGroup) {
          dealTaskGroupRequiredFields.forEach((field: string): void => {
            if ((!dealTaskGroup[field] || !dealTaskGroup[field].toString().trim()) && dealTaskGroup[field] !== null) {
              errors.initialData.dealTaskGroups[dealTaskGroupIndex][field] = 'Required';
            }
          });

          if (dealTaskGroup.tasks && Object.keys(dealTaskGroup.tasks).length) {
            errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks = {};

            Object.keys(dealTaskGroup.tasks).forEach((dealTaskIndex: string): void => {
              errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex] = {};

              const dealTask: ValidationEntityInput = dealTaskGroup.tasks[dealTaskIndex];

              if (dealTask) {
                dealTaskRequiredFields.forEach((field: string): void => {
                  if ((!dealTask[field] || !dealTask[field].toString().trim()) && dealTask[field] !== null) {
                    errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex][field] = 'Required';
                  }
                });

                if (dealTask.subTasks && Object.keys(dealTask.subTasks).length) {
                  errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex].subTasks = {};

                  Object.keys(dealTask.subTasks).forEach((dealSubTaskIndex: string): void => {
                    errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex]
                      .subTasks[dealSubTaskIndex] = {};

                    const dealSubTask: ValidationEntityInput = dealTask.subTasks[dealSubTaskIndex];

                    if (dealSubTask) {
                      dealTaskRequiredFields.forEach((field: string): void => {
                        if ((!dealSubTask[field] || !dealSubTask[field].toString().trim())
                          && dealSubTask[field] !== null) {
                          errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex]
                            .subTasks[dealSubTaskIndex][field] = 'Required';
                        }
                      });
                    }

                    if (errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex]
                      .subTasks[dealSubTaskIndex] && !Object.keys(errors.initialData
                      .dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex].subTasks[dealSubTaskIndex]).length) {
                      delete errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex]
                        .subTasks[dealSubTaskIndex];
                    }
                  });

                  if (errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex].subTasks
                    && !Object.keys(errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex]
                      .subTasks).length) {
                    delete errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex].subTasks;
                  }
                }
              }

              if (errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex]
                && !Object.keys(errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex]).length) {
                delete errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks[dealTaskIndex];
              }
            });

            if (errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks
              && !Object.keys(errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks).length) {
              delete errors.initialData.dealTaskGroups[dealTaskGroupIndex].tasks;
            }
          }
        }

        if (errors.initialData.dealTaskGroups[dealTaskGroupIndex]
          && !Object.keys(errors.initialData.dealTaskGroups[dealTaskGroupIndex]).length) {
          delete errors.initialData.dealTaskGroups[dealTaskGroupIndex];
        }
      });
    }
    if (errors.initialData.dealTaskGroups && !Object.keys(errors.initialData.dealTaskGroups).length) {
      delete errors.initialData.dealTaskGroups;
    }

    errors.initialData.dealFileGroups = {};
    if (values.initialData.dealFileGroups && Object.keys(values.initialData.dealFileGroups).length) {
      Object.keys(values.initialData.dealFileGroups).forEach((dealFileGroupIndex: string): void => {
        errors.initialData.dealFileGroups[dealFileGroupIndex] = {};

        const dealFileGroup: ValidationEntityInput = values.initialData.dealFileGroups[dealFileGroupIndex];

        if (dealFileGroup) {
          dealFileGroupRequiredFields.forEach((field: string): void => {
            if ((!dealFileGroup[field] || !dealFileGroup[field].toString().trim()) && dealFileGroup[field] !== null) {
              errors.initialData.dealFileGroups[dealFileGroupIndex][field] = 'Required';
            }
          });
        }

        if (errors.initialData.dealFileGroups[dealFileGroupIndex]
          && !Object.keys(errors.initialData.dealFileGroups[dealFileGroupIndex]).length) {
          delete errors.initialData.dealFileGroups[dealFileGroupIndex];
        }
      });
    }
    if (errors.initialData.dealFileGroups && !Object.keys(errors.initialData.dealFileGroups).length) {
      delete errors.initialData.dealFileGroups;
    }

    errors.initialData.dealParticipantGroups = {};
    if (values.initialData.dealParticipantGroups && Object.keys(values.initialData.dealParticipantGroups).length) {
      Object.keys(values.initialData.dealParticipantGroups).forEach((dealParticipantGroupIndex: string): void => {
        errors.initialData.dealParticipantGroups[dealParticipantGroupIndex] = {};

        const dealParticipantGroup: ValidationEntityInput = values.initialData
          .dealParticipantGroups[dealParticipantGroupIndex];

        if (dealParticipantGroup) {
          dealParticipantGroupRequiredFields.forEach((field: string): void => {
            if ((!dealParticipantGroup[field] || !dealParticipantGroup[field].toString().trim())
              && dealParticipantGroup[field] !== null) {
              errors.initialData.dealParticipantGroups[dealParticipantGroupIndex][field] = 'Required';
            }
          });
        }

        if (errors.initialData.dealParticipantGroups[dealParticipantGroupIndex]
          && !Object.keys(errors.initialData.dealParticipantGroups[dealParticipantGroupIndex]).length) {
          delete errors.initialData.dealParticipantGroups[dealParticipantGroupIndex];
        }
      });
    }
    if (errors.initialData.dealParticipantGroups && !Object.keys(errors.initialData.dealParticipantGroups).length) {
      delete errors.initialData.dealParticipantGroups;
    }
  }

  if (errors.initialData && !Object.keys(errors.initialData).length) {
    delete errors.initialData;
  }

  if (values.customSections && Object.keys(values.customSections).length) {
    errors.customSections = {};

    Object.keys(values.customSections).forEach((dealTemplateCustomSectionIndex: string): void => {
      errors.customSections[dealTemplateCustomSectionIndex] = {};

      const dealTemplateCustomSection: ValidationEntityInput = values.customSections[dealTemplateCustomSectionIndex];

      if (dealTemplateCustomSection) {
        customSectionRequiredFields.forEach((field: string): void => {
          if ((!dealTemplateCustomSection[field] || !dealTemplateCustomSection[field].toString().trim())
            && dealTemplateCustomSection[field] !== null && dealTemplateCustomSection.fields
            && Object.keys(dealTemplateCustomSection.fields).length) {
            errors.customSections[dealTemplateCustomSectionIndex][field] = 'Required';
          }
        });

        if (dealTemplateCustomSection.fields && Object.keys(dealTemplateCustomSection.fields).length) {
          errors.customSections[dealTemplateCustomSectionIndex].fields = {};

          Object.keys(dealTemplateCustomSection.fields).forEach((dealTemplateCustomSectionFieldIndex: string): void => {
            errors.customSections[dealTemplateCustomSectionIndex].fields[dealTemplateCustomSectionFieldIndex] = {};

            const dealTemplateCustomSectionField: ValidationEntityInput = dealTemplateCustomSection
              .fields[dealTemplateCustomSectionFieldIndex];

            if (dealTemplateCustomSectionField) {
              customSectionFieldRequiredFields.forEach((field: string): void => {
                if ((!dealTemplateCustomSectionField[field] || !dealTemplateCustomSectionField[field].toString().trim())
                  && dealTemplateCustomSectionField[field] !== null) {
                  errors.customSections[dealTemplateCustomSectionIndex].fields[dealTemplateCustomSectionFieldIndex]
                    [field] = 'Required';
                }
              });

              if (dealTemplateCustomSectionField.type === FIELD_TYPE_DROPDOWN
                && !dealTemplateCustomSectionField.listType) {
                errors.customSections[dealTemplateCustomSectionIndex].fields[dealTemplateCustomSectionFieldIndex]
                  .listType = 'Required';
              }
            }

            if (errors.customSections[dealTemplateCustomSectionIndex].fields[dealTemplateCustomSectionFieldIndex]
              && !Object.keys(errors.customSections[dealTemplateCustomSectionIndex]
                .fields[dealTemplateCustomSectionFieldIndex]).length) {
              delete errors.customSections[dealTemplateCustomSectionIndex].fields[dealTemplateCustomSectionFieldIndex];
            }
          });

          if (errors.customSections[dealTemplateCustomSectionIndex].fields
            && !Object.keys(errors.customSections[dealTemplateCustomSectionIndex].fields).length) {
            delete errors.customSections[dealTemplateCustomSectionIndex].fields;
          }
        }
      }

      if (errors.customSections[dealTemplateCustomSectionIndex]
        && !Object.keys(errors.customSections[dealTemplateCustomSectionIndex]).length) {
        delete errors.customSections[dealTemplateCustomSectionIndex];
      }
    });
  }

  if (errors.customSections && !Object.keys(errors.customSections).length) {
    delete errors.customSections;
  }

  if (values.customListTypes && Object.keys(values.customListTypes).length) {
    errors.customListTypes = {};

    Object.keys(values.customListTypes).forEach((dealTemplateCustomListTypeIndex: string): void => {
      errors.customListTypes[dealTemplateCustomListTypeIndex] = {};

      const dealTemplateCustomListType: ValidationEntityInput = values.customListTypes[dealTemplateCustomListTypeIndex];

      if (dealTemplateCustomListType) {
        customListTypeRequiredFields.forEach((field: string): void => {
          if ((!dealTemplateCustomListType[field] || !dealTemplateCustomListType[field].toString().trim())
            && dealTemplateCustomListType[field] !== null && dealTemplateCustomListType.options
            && Object.keys(dealTemplateCustomListType.options).length) {
            errors.customListTypes[dealTemplateCustomListTypeIndex][field] = 'Required';
          }
        });

        if (dealTemplateCustomListType.options && Object.keys(dealTemplateCustomListType.options).length) {
          errors.customListTypes[dealTemplateCustomListTypeIndex].options = {};

          Object.keys(dealTemplateCustomListType.options).forEach((
            dealTemplateCustomListTypeOptionIndex: string,
          ): void => {
            errors.customListTypes[dealTemplateCustomListTypeIndex].options[dealTemplateCustomListTypeOptionIndex] = {};

            const dealTemplateCustomListTypeOption: ValidationEntityInput = dealTemplateCustomListType
              .options[dealTemplateCustomListTypeOptionIndex];

            if (dealTemplateCustomListTypeOption) {
              customListTypeOptionRequiredFields.forEach((field: string): void => {
                if ((!dealTemplateCustomListTypeOption[field]
                    || !dealTemplateCustomListTypeOption[field].toString().trim())
                  && dealTemplateCustomListTypeOption[field] !== null) {
                  errors.customListTypes[dealTemplateCustomListTypeIndex].options[dealTemplateCustomListTypeOptionIndex]
                    [field] = 'Required';
                }
              });
            }

            if (errors.customListTypes[dealTemplateCustomListTypeIndex].options[dealTemplateCustomListTypeOptionIndex]
              && !Object.keys(errors.customListTypes[dealTemplateCustomListTypeIndex]
                .options[dealTemplateCustomListTypeOptionIndex]).length) {
              delete errors.customListTypes[dealTemplateCustomListTypeIndex]
                .options[dealTemplateCustomListTypeOptionIndex];
            }
          });

          if (errors.customListTypes[dealTemplateCustomListTypeIndex].options
            && !Object.keys(errors.customListTypes[dealTemplateCustomListTypeIndex].options).length) {
            delete errors.customListTypes[dealTemplateCustomListTypeIndex].options;
          }
        }
      }

      if (errors.customListTypes[dealTemplateCustomListTypeIndex]
        && !Object.keys(errors.customListTypes[dealTemplateCustomListTypeIndex]).length) {
        delete errors.customListTypes[dealTemplateCustomListTypeIndex];
      }
    });
  }

  if (errors.customListTypes && !Object.keys(errors.customListTypes).length) {
    delete errors.customListTypes;
  }

  return errors;
};

export default SettingsDealTemplateValidator;
